// ---- Shopify.formatMoney function ----
if (!window.Shopify.formatMoney) {
  Shopify.formatMoney = function (cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    format = format || Shopify.money_format;

    function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
      number = (number / 100).toFixed(precision);
      const parts = number.split(".");
      const dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      const centsPart = parts[1] ? decimal + parts[1] : "";
      return dollars + centsPart;
    }

    let value;
    switch (format) {
      case "${{amount}}":
        value = formatWithDelimiters(cents, 2);
        break;
      case "${{amount_no_decimals}}":
        value = formatWithDelimiters(cents, 0);
        break;
      case "${{amount_with_comma_separator}}":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "${{amount_no_decimals_with_comma_separator}}":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, value);
  };
}

// =========================== Seed-3 AB test JS ===========================
function extractPrice(text) {
  if (!text) return 0;
  let cleaned = text.replace(/^[^\d]+/, '').trim();
  if (/^\d{1,3}(\.\d{3})*,\d{2}$/.test(cleaned) || (cleaned.includes(',') && !cleaned.includes('.'))) {
    cleaned = cleaned.replace(/\./g, '').replace(',', '.');
  } else {
    cleaned = cleaned.replace(/,/g, '');
  }

  return parseFloat(cleaned) || 0;
}

function addBundleSavings() {
  const bars = document.querySelectorAll('.seed-3_ab-test .kaching-bundles__bar');
  bars.forEach((bar, index) => {
    if (index === 0) return;

    const priceEl = bar.querySelector('.kaching-bundles__bar-price');
    const compareEl = bar.querySelector('.kaching-bundles__bar-full-price');
    const titleEl = bar.querySelector('.kaching-bundles__bar-title');
    if (!priceEl || !compareEl || !titleEl) return;

    const oldBadge = bar.querySelector('.bundle-saving');
    if (oldBadge) oldBadge.remove();

    const price = extractPrice(priceEl.textContent);
    const compare = extractPrice(compareEl.textContent);
    if (isNaN(price) || isNaN(compare)) return;

    const saving = compare - price;
    if (saving <= 0) return;

    const savingInCents = Math.round(saving * 100);

    let formattedSaving = window.Shopify?.formatMoney ? Shopify.formatMoney(savingInCents, '${{amount_no_decimals}}') : Math.floor(saving).toString();
    formattedSaving = formattedSaving.replace(/[.,]\d{2}/, '');

    const badge = document.createElement('span');
    badge.className = 'bundle-saving';
    badge.textContent = `${formattedSaving} OFF`;
    titleEl.appendChild(badge);
  });
}

// function updateBundleTitle() {
//   const titles = document.querySelectorAll('.seed-3_ab-test .kaching-bundles__block-title');
//   titles.forEach(el => {
//     if (el.textContent !== 'LIMITED OFFER: Ending soon') {
//       el.textContent = 'LIMITED OFFER: Ending soon';
//     }
//   });
// }

function updateBundleTitle() {
  const titles = document.querySelectorAll('.seed-3_ab-test .kaching-bundles__block-title, .quiz-result--template .kaching-bundles__block-title');
  titles.forEach(el => {
    if (el.closest('.quiz-result--template')) {
      el.textContent = 'Your result recommend 5 months for a full follicle cycle';
    } else {
      el.textContent = 'LIMITED OFFER: Ending soon';
    }
  });
}

// Keep the quiz result CTA price in sync with the selected product variant.
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const price = document.querySelector(
      `#ProductSubmitButton-${event.data.sectionId} [data-quiz-result-price]`
    );
    if (!price || !event.data.variant) return;

    price.textContent = Shopify.formatMoney(event.data.variant.price, Shopify.money_format);
  });
}

function observeSubscriptionCheckbox() {
  const checkbox = document.querySelector('.seed-3_ab-test .kaching-bundles__subscriptions__checkbox');
  if (!checkbox) return;

  const updateState = () => {
    const svg = checkbox.querySelector('svg');
    checkbox.classList.toggle('subscription-unchecked', !svg);
    addBundleSavings();
  };

  const observer = new MutationObserver(updateState);
  observer.observe(checkbox, {
    childList: true,
    subtree: true
  });

  updateState();
}

let timeout;
const mainObserver = new MutationObserver(() => {
  clearTimeout(timeout);
  timeout = setTimeout(() => {
    addBundleSavings();
    updateBundleTitle();
  }, 100);
});
mainObserver.observe(document.body, {
  childList: true,
  subtree: true
});
addBundleSavings();
updateBundleTitle();
setTimeout(observeSubscriptionCheckbox, 1500);


// =========================== ID0007 - PDP - CTA section v2 ================================
(function () {
  function addStaticBadges() {
    const bundleBars = document.querySelectorAll('.seed-3_ab-test-2 .kaching-bundles__bar');
    if (!bundleBars.length) return;

    bundleBars.forEach((bar, index) => {
      const titleEl = bar.querySelector('.kaching-bundles__bar-title');
      if (!titleEl) return;

      // prevent duplicate badge
      if (bar.dataset.badgeAdded === 'true') return;

      let badgeText = '';
      if (index === 1) badgeText = 'MOST POPULAR';
      else if (index === 2) badgeText = 'SUPER VALUE';
      else return;

      const badge = document.createElement('span');
      badge.className = 'bundle-saving';
      badge.textContent = badgeText;

      titleEl.appendChild(badge);
      bar.dataset.badgeAdded = 'true';
    });
  }

  function observeSubscriptionCheckboxSeed3() {
    const checkbox = document.querySelector('.seed-3_ab-test-2 .kaching-bundles__subscriptions__checkbox');
    if (!checkbox) return;

    const updateState = () => {
      const svg = checkbox.querySelector('svg');
      checkbox.classList.toggle('subscription-unchecked', !svg);
      addBundleSavings();
    };

    const observer = new MutationObserver(updateState);
    observer.observe(checkbox, {
      childList: true,
      subtree: true
    });

    updateState();
  }

  function updateBundleTitle() {
    const titles = document.querySelectorAll('.seed-3_ab-test-2 .kaching-bundles__block-title');
    titles.forEach(el => {
      if (el.textContent !== 'FREE SHIPPING - TODAY ONLY') {
        el.textContent = 'FREE SHIPPING - TODAY ONLY';
      }
    });
  }

  function initObserver() {
    let timeout;
    const observer = new MutationObserver(() => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        addStaticBadges();
        updateBundleTitle();
      }, 100);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function init() {
    addStaticBadges();
    updateBundleTitle();
    initObserver();
  }
  setTimeout(observeSubscriptionCheckboxSeed3, 1500);
  init();
})();

//============================ Cart Update =================================
function updateCartHeading() {
  const headings = document.querySelectorAll('.kaching-cart__heading');

  headings.forEach(el => {
    let text = el.textContent.trim();

    // Extract number from "• 5" OR "(5)" OR "5"
    const match = text.match(/(\d+)/);
    const count = match ? match[1] : '';

    const finalText = count ? `Your Cart (${count})` : 'Your Cart';

    if (el.textContent !== finalText) {
      el.textContent = finalText;
    }
  });
}

let cartTimeout;

const observer = new MutationObserver((mutations) => {

  updateCartHeading();

  clearTimeout(cartTimeout);
  cartTimeout = setTimeout(() => {
    updateCartHeading();
  }, 300);

});

function initObserver() {
  const target = document.body;

  if (!target) {
    setTimeout(initObserver, 500);
    return;
  }

  observer.observe(target, {
    childList: true,
    subtree: true
  });

  // initial run
  updateCartHeading();
}

initObserver();

//============================== Global - Cart AB-Test JS ================================
(function () {

  let cartTimeout;

  function updateTrustBadges() {
    const container = document.querySelector('.kaching-cart__trust-badges');
    if (!container) return;

    if (container.querySelector('.custom-close-cart-badge')) return;

    const badge = document.createElement('div');
    badge.className = 'kaching-cart__trust-badge custom-close-cart-badge';

    badge.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"></path></svg>
    `;

    badge.style.cursor = 'pointer';

    badge.addEventListener('click', () => {
      document.querySelector('.kaching-cart__close')?.click();
    });

    container.appendChild(badge);
  }

  function updateFreeGiftItems() {
    const freeItems = document.querySelectorAll(
      '.kaching-cart-item__kaching-bundles-free-gift'
    );
    freeItems.forEach(item => {

      const qtyWrapper = item.querySelector('.kaching-cart-item__quantity-controls');
      if (qtyWrapper) {
        qtyWrapper.style.display = 'none';
      }

      const infoBlock = item.querySelector('.kaching-cart-item__info');

      if (infoBlock && !item.querySelector('.custom-free-gift-badge')) {

        const badge = document.createElement('div');
        badge.className = 'custom-free-gift-badge';

        badge.innerHTML = `
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M8 4.8894V15.0002M1 5.66716C1 5.46089 1.08194 5.26306 1.22781 5.1172C1.37367 4.97135 1.5715 4.8894 1.77778 4.8894H14.2222C14.4285 4.8894 14.6263 4.97135 14.7722 5.1172C14.9181 5.26306 15 5.46089 15 5.66716V7.22267C15 7.42894 14.9181 7.62677 14.7722 7.77262C14.6263 7.91848 14.4285 8.00042 14.2222 8.00042H1.77778C1.5715 8.00042 1.37367 7.91848 1.22781 7.77262C1.08194 7.62677 1 7.42894 1 7.22267V5.66716Z" stroke="#079455" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M13.4444 7.99989V13.4442C13.4444 13.8567 13.2805 14.2524 12.9888 14.5441C12.6971 14.8358 12.3014 14.9997 11.8889 14.9997H4.1111C3.69854 14.9997 3.30288 14.8358 3.01115 14.5441C2.71943 14.2524 2.55554 13.8567 2.55554 13.4442V7.99989M4.49999 4.88887C3.98429 4.88887 3.48971 4.68401 3.12506 4.31937C2.7604 3.95473 2.55554 3.46017 2.55554 2.94448C2.55554 2.4288 2.7604 1.93424 3.12506 1.56959C3.48971 1.20495 3.98429 1.0001 4.49999 1.0001C5.2503 0.987024 5.98556 1.35107 6.60989 2.04474C7.23422 2.73842 7.71865 3.72955 7.99999 4.88887C8.28133 3.72955 8.76575 2.73842 9.39008 2.04474C10.0144 1.35107 10.7497 0.987024 11.5 1.0001C12.0157 1.0001 12.5103 1.20495 12.8749 1.56959C13.2396 1.93424 13.4444 2.4288 13.4444 2.94448C13.4444 3.46017 13.2396 3.95473 12.8749 4.31937C12.5103 4.68401 12.0157 4.88887 11.5 4.88887" stroke="#079455" stroke-width="1.5"/>
          </svg>
          <span>Free Gift</span>
        `;

        infoBlock.appendChild(badge);
      }

      const finalPrice = item.querySelector('.kaching-cart-item__total-final');

      if (finalPrice) {
        let formattedZero = '0.00';

        if (window.Shopify && Shopify.formatMoney) {
          console.log("yyyyyyyyyyyyyyyyyyyyyy");
          formattedZero = Shopify.formatMoney(0, Shopify.money_format);
        } else {
          console.log("nnnnnnnnnnnnnnnn");
        }

        finalPrice.textContent = formattedZero;
      }

    });
  }

  let savingElRef = null;

  function updateCartSavingSimple() {
    if (document.querySelector('.kaching-cart__citom-saving')) {
      return;
    }
    const wrapper = document.querySelector('.kaching-cart__subtotal');
    if (!wrapper) return;

    const span = wrapper.querySelector('span');
    const originalEl = wrapper.querySelector('.kaching-cart__subtotal-original');

    if (!span || !originalEl) return;

    const original = extractPrice(originalEl.textContent);

    const finalText = span.cloneNode(true);
    finalText.querySelector('.kaching-cart__subtotal-original')?.remove();

    const final = extractPrice(finalText.textContent);

    const saving = original - final;

    const savingInCents = Math.round(saving * 100);

    let formattedSaving = saving.toFixed(2);

    if (window.Shopify && Shopify.formatMoney) {
      console.log("rrrrrrrrrrr");
      formattedSaving = Shopify.formatMoney(savingInCents, Shopify.money_format);
    } else {
      console.log("nnnnnnnnnnnnn");

    }

    if (saving <= 0) {
      const old = wrapper.querySelector('.kaching-cart__citom-saving');
      if (old) old.remove();
      return;
    }

    let savingEl = wrapper.querySelector('.kaching-cart__citom-saving');

    if (!savingEl) {
      savingEl = document.createElement('span');
      savingEl.className = 'kaching-cart__citom-saving';
      originalEl.parentNode.insertBefore(savingEl, originalEl);
    }

    savingEl.textContent = `Save ${formattedSaving}`;
  }


  let rafId = null;

  function runCartUpdates() {
    if (rafId) return;

    rafId = requestAnimationFrame(() => {
      updateTrustBadges();
      updateFreeGiftItems();
      updateCartSavingSimple();

      rafId = null;
    });
  }

  function initObserver() {
    const target = document.querySelector('.kaching-cart__inner');
    if (!target) {
      setTimeout(initObserver, 300);
      return;
    }

    const observer = new MutationObserver(() => {
      runCartUpdates();
    });

    observer.observe(target, {
      childList: true,
      subtree: true
    });

    runCartUpdates();
  }


  initObserver();

})();

// ============================= Custom Free Gift Changes ===============================

// Gift products of the shared free gift flow (snippets/free-gift-global-data + free-gift-serum):
// the eBook (window.freeGiftData) and the serum (window.freeSerumGift).
function getFreeGiftProducts() {
  return [window.freeGiftData, window.freeSerumGift].filter((gift) => gift?.variantId);
}

function isFreeGiftVariant(variantId) {
  return getFreeGiftProducts().some((gift) => Number(gift.variantId) === Number(variantId));
}

function getFreeGiftCartElements(handles) {
  const selector = handles
    .filter(Boolean)
    .map((handle) => `.kaching-cart-item[data-product-handle="${handle}"]`)
    .join(',');
  return selector ? document.querySelectorAll(selector) : [];
}

// ─── Update Free Gift UI (badge + hide qty controls) ─────────────────────────
function updateFreeGiftItems() {
  const freeItems = document.querySelectorAll('.kaching-cart-item__kaching-bundles-free-gift');

  const customGiftItems = getFreeGiftCartElements(getFreeGiftProducts().map((gift) => gift.handle));

  const allFreeGiftItems = [...freeItems, ...customGiftItems];

  allFreeGiftItems.forEach((item) => {
    const qtyWrapper = item.querySelector('.kaching-cart-item__quantity-controls');
    if (qtyWrapper) qtyWrapper.style.display = 'none';

    const infoBlock = item.querySelector('.kaching-cart-item__info');
    if (infoBlock && !item.querySelector('.custom-free-gift-badge')) {
      const badge = document.createElement('div');
      badge.className = 'custom-free-gift-badge';
      badge.innerHTML = `
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M8 4.8894V15.0002M1 5.66716C1 5.46089 1.08194 5.26306 1.22781 5.1172C1.37367 4.97135 1.5715 4.8894 1.77778 4.8894H14.2222C14.4285 4.8894 14.6263 4.97135 14.7722 5.1172C14.9181 5.26306 15 5.46089 15 5.66716V7.22267C15 7.42894 14.9181 7.62677 14.7722 7.77262C14.6263 7.91848 14.4285 8.00042 14.2222 8.00042H1.77778C1.5715 8.00042 1.37367 7.91848 1.22781 7.77262C1.08194 7.62677 1 7.42894 1 7.22267V5.66716Z" stroke="#079455" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M13.4444 7.99989V13.4442C13.4444 13.8567 13.2805 14.2524 12.9888 14.5441C12.6971 14.8358 12.3014 14.9997 11.8889 14.9997H4.1111C3.69854 14.9997 3.30288 14.8358 3.01115 14.5441C2.71943 14.2524 2.55554 13.8567 2.55554 13.4442V7.99989M4.49999 4.88887C3.98429 4.88887 3.48971 4.68401 3.12506 4.31937C2.7604 3.95473 2.55554 3.46017 2.55554 2.94448C2.55554 2.4288 2.7604 1.93424 3.12506 1.56959C3.48971 1.20495 3.98429 1.0001 4.49999 1.0001C5.2503 0.987024 5.98556 1.35107 6.60989 2.04474C7.23422 2.73842 7.71865 3.72955 7.99999 4.88887C8.28133 3.72955 8.76575 2.73842 9.39008 2.04474C10.0144 1.35107 10.7497 0.987024 11.5 1.0001C12.0157 1.0001 12.5103 1.20495 12.8749 1.56959C13.2396 1.93424 13.4444 2.4288 13.4444 2.94448C13.4444 3.46017 13.2396 3.95473 12.8749 4.31937C12.5103 4.68401 12.0157 4.88887 11.5 4.88887" stroke="#079455" stroke-width="1.5"/>
        </svg>
        <span>Free Gift</span>
      `;
      infoBlock.appendChild(badge);
    }
  });
}

// ─── Remove Free Gift if ALL linked variants removed from cart ────────────────
// Logic:

async function removeFreeGiftFromCart() {
  if (window.__removingGift) return;
  window.__removingGift = true;

  try {
    if (!getFreeGiftProducts().length) return;

    const cart = await fetch('/cart.js').then((res) => res.json());

    const freeGiftItems = cart.items.filter((item) => isFreeGiftVariant(item.variant_id));

    if (!freeGiftItems.length) return;

    const pairedGiftGroups = {};
    freeGiftItems.forEach((giftItem) => {
      const rowId = getLinkedCartRowId(giftItem);
      if (rowId) (pairedGiftGroups[rowId] = pairedGiftGroups[rowId] || []).push(giftItem);
    });
    for (const giftLines of Object.values(pairedGiftGroups)) {
      await trimPairedGiftLines(cart, giftLines);
    }

    for (const giftItem of freeGiftItems) {
      if (getLinkedCartRowId(giftItem)) continue;

      const allocationState = getSerumGiftAllocationState(giftItem, cart);
      if (allocationState) {
        if (!allocationState.quantity) {
          await _removeGiftItem(giftItem, cart);
          continue;
        }
        const allocationJson = JSON.stringify(allocationState.allocations);
        const linkedJson = Object.keys(allocationState.allocations).join(',');
        if (
          Number(giftItem.quantity) !== allocationState.quantity ||
          giftItem.properties?._free_gift_allocations !== allocationJson ||
          giftItem.properties?._linked_variants !== linkedJson
        ) {
          const freshCart = await fetch('/cart.js').then((res) => res.json());
          const lineIndex = freshCart.items.findIndex((item) => item.key === giftItem.key);
          if (lineIndex !== -1) await fetch('/cart/change.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              line: lineIndex + 1,
              quantity: allocationState.quantity,
              properties: {
                ...giftItem.properties,
                _free_gift_allocations: allocationJson,
                _linked_variants: linkedJson,
              },
            }),
          });
        }
        continue;
      }

      const linkedStr = giftItem.properties?._linked_variants || '';

      const linkedIds = linkedStr
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean)
        .map(Number);

      if (!linkedIds.length) {
        console.log('No linked variants found on gift — removing as orphan');
        await _removeGiftItem(giftItem, cart);
        continue;
      }

      const anyLinkedExists = linkedIds.some((linkedId) =>
        cart.items.some(
          (item) =>
            Number(item.variant_id) === Number(linkedId) &&
            !isFreeGiftVariant(item.variant_id)
        )
      );

      if (anyLinkedExists) {
        console.log('At least one linked variant still in cart — keeping gift');
        continue;
      }

      console.log('All linked variants removed — removing free gift');
      await _removeGiftItem(giftItem, cart);
    }
  } catch (err) {
    console.error('Free gift remove error:', err);
  } finally {
    setTimeout(() => {
      window.__removingGift = false;
    }, 100);
  }
}

function scheduleFreeGiftCartCleanup(delay = 250) {
  clearTimeout(window.__giftRemoveTimer);
  window.__giftRemoveTimer = setTimeout(() => {
    removeFreeGiftFromCart();
  }, delay);
}

function runFreeGiftCartCleanupAfter(delay = 250) {
  // ✅ Consolidate: only schedule one cleanup, not multiple
  scheduleFreeGiftCartCleanup(delay);
}

function parseCartChangePayload(options = {}) {
  const body = options.body;
  if (!body) return null;

  if (typeof body === 'string') {
    try {
      return JSON.parse(body);
    } catch (error) {
      return Object.fromEntries(new URLSearchParams(body));
    }
  }

  if (body instanceof FormData || body instanceof URLSearchParams) {
    return Object.fromEntries(body.entries());
  }

  return null;
}

function getLinkedVariantIds(giftItem) {
  return String(giftItem.properties?._linked_variants || '')
    .split(',')
    .map((id) => Number(id.trim()))
    .filter(Boolean);
}

function getSerumGiftAllocationState(giftItem, cart, removedItemKeys = []) {
  if (giftItem.properties?._free_gift_type !== 'serum') return null;

  let storedAllocations = {};
  if (giftItem.properties?._free_gift_allocations) {
    try {
      storedAllocations = JSON.parse(giftItem.properties._free_gift_allocations);
    } catch (error) {
      return null;
    }
  } else {
    // Upgrade older serum gift lines on the fly using bundle metafields.
    getLinkedVariantIds(giftItem).forEach((id) => {
      const mappedQuantity = Number(window.variantFreeSerumMap?.[id]?.quantity || 0);
      if (mappedQuantity > 0) storedAllocations[id] = mappedQuantity;
    });
    if (!Object.keys(storedAllocations).length) return null;
  }

  const allocations = {};
  const linkedIds = new Set([
    ...Object.keys(storedAllocations || {}).map(Number),
    ...getLinkedVariantIds(giftItem),
  ]);

  cart.items.forEach((item) => {
    if (removedItemKeys.includes(item.key) || isFreeGiftVariant(item.variant_id)) return;
    const id = Number(item.variant_id);
    if (!linkedIds.has(id)) return;
    const perItemGiftQuantity = Number(item.properties?._free_serum_quantity || 0);
    const fallbackQuantity = Number(storedAllocations?.[id] || 0);
    const quantity = perItemGiftQuantity > 0
      ? perItemGiftQuantity * Number(item.quantity || 1)
      : (linkedIds.has(id) ? fallbackQuantity : 0);
    if (quantity > 0) {
      allocations[id] = (allocations[id] || 0) + quantity;
    }
  });

  return {
    allocations,
    quantity: Object.values(allocations).reduce((total, quantity) => total + quantity, 0),
  };
}

// Serum gift lines carry _linked_cart_row_id: the _cart_row_id of the one main line they were added with.
function getLinkedCartRowId(giftItem) {
  return giftItem.properties?._linked_cart_row_id || '';
}

// Each serum of a main line is its own gift line (quantity 1). The lines are removed once the main
// line is gone, and trimmed when it needs fewer serums. They are never re-added, so a gift line the
// customer removed stays removed.
async function trimPairedGiftLines(cart, giftLines) {
  const rowId = getLinkedCartRowId(giftLines[0]);
  const mainItem = cart.items.find(
    (item) => !isFreeGiftVariant(item.variant_id) && item.properties?._cart_row_id === rowId
  );

  const currentQuantity = giftLines.reduce((total, item) => total + Number(item.quantity || 0), 0);
  let wantedQuantity = 0;
  if (mainItem) {
    const perItemGiftQuantity = Number(mainItem.properties?._free_serum_quantity || 0);
    wantedQuantity = perItemGiftQuantity > 0 ? perItemGiftQuantity * Number(mainItem.quantity || 1) : currentQuantity;
  }

  let extra = currentQuantity - wantedQuantity;
  if (extra <= 0) return;

  const updates = {};
  for (const giftItem of [...giftLines].reverse()) {
    if (extra <= 0) break;
    const removeQuantity = Math.min(extra, Number(giftItem.quantity || 0));
    updates[giftItem.key] = Number(giftItem.quantity || 0) - removeQuantity;
    extra -= removeQuantity;
  }

  await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates }),
  });
}

function getGiftItemsLinkedToItem(cart, mainItem) {
  const variantId = mainItem.variant_id;
  return cart.items.filter((item) => {
    if (!isFreeGiftVariant(item.variant_id)) return false;
    if (getLinkedCartRowId(item)) return getLinkedCartRowId(item) === mainItem.properties?._cart_row_id;
    if (getLinkedVariantIds(item).includes(Number(variantId))) return true;

    if (item.properties?._free_gift_type === 'serum' && item.properties?._free_gift_allocations) {
      try {
        return Object.prototype.hasOwnProperty.call(
          JSON.parse(item.properties._free_gift_allocations),
          String(variantId)
        );
      } catch (error) {
        return false;
      }
    }

    return false;
  });
}

function hasRemainingLinkedMainItem(cart, linkedIds, removedItemKeys) {
  return linkedIds.some((linkedId) =>
    cart.items.some(
      (item) =>
        !removedItemKeys.includes(item.key) &&
        Number(item.variant_id) === Number(linkedId) &&
        !isFreeGiftVariant(item.variant_id)
    )
  );
}

function getCartChangeRemovedItem(cart, payload) {
  if (payload.line) return cart.items[Number(payload.line) - 1];
  if (!payload.id) return null;

  const id = String(payload.id);
  return cart.items.find(
    (item) => item.key === id || String(item.variant_id) === id || String(item.id) === id
  );
}

async function removeMainItemWithLinkedGift(args, originalFetch, cart) {
  const [url, options = {}] = args;
  if (!String(url?.url || url || '').includes('/cart/change.js')) return null;

  const payload = parseCartChangePayload(options);
  if (!payload || Number(payload.quantity) !== 0 || (!payload.line && !payload.id)) return null;

  if (!getFreeGiftProducts().length) return null;

  if (!cart) return null;
  const removedItem = getCartChangeRemovedItem(cart, payload);
  if (!removedItem || isFreeGiftVariant(removedItem.variant_id)) return null;

  const linkedGiftItems = getGiftItemsLinkedToItem(cart, removedItem);
  if (!linkedGiftItems.length) return null;

  const updates = {
    [removedItem.key]: 0,
  };

  linkedGiftItems.forEach((giftItem) => {
    if (getLinkedCartRowId(giftItem)) {
      updates[giftItem.key] = 0;
      return;
    }

    const allocationState = getSerumGiftAllocationState(giftItem, cart, [removedItem.key]);
    if (allocationState) {
      updates[giftItem.key] = allocationState.quantity;
      return;
    }

    const linkedIds = getLinkedVariantIds(giftItem);
    const otherLinkedItemExists = hasRemainingLinkedMainItem(cart, linkedIds, [removedItem.key]);

    if (!otherLinkedItemExists) {
      updates[giftItem.key] = 0;
    }
  });

  if (Object.keys(updates).length === 1) return null;

  window.__removingGift = true;

  try {
    return await originalFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates }),
    });
  } finally {
    setTimeout(() => {
      window.__removingGift = false;
      scheduleFreeGiftCartCleanup(250);
    }, 100);
  }
}

async function updateCartWithLinkedGiftRemoval(args, originalFetch, cart) {
  const [url, options = {}] = args;
  const urlString = String(url?.url || url || '');
  if (!urlString.includes('/cart/update.js')) return null;

  const payload = parseCartChangePayload(options);
  if (!payload?.updates || typeof payload.updates !== 'object') return null;

  if (!getFreeGiftProducts().length) return null;

  if (!cart) return null;
  const removedItems = cart.items.filter((item) => {
    const updateValue = payload.updates[item.key] ?? payload.updates[item.variant_id] ?? payload.updates[item.id];
    return Number(updateValue) === 0 && !isFreeGiftVariant(item.variant_id);
  });

  if (!removedItems.length) return null;

  const removedItemKeys = removedItems.map((item) => item.key);
  const nextUpdates = { ...payload.updates };

  removedItems.forEach((removedItem) => {
    const linkedGiftItems = getGiftItemsLinkedToItem(cart, removedItem);

    linkedGiftItems.forEach((giftItem) => {
      if (getLinkedCartRowId(giftItem)) {
        nextUpdates[giftItem.key] = 0;
        return;
      }

      const allocationState = getSerumGiftAllocationState(giftItem, cart, removedItemKeys);
      if (allocationState) {
        nextUpdates[giftItem.key] = allocationState.quantity;
        return;
      }

      const linkedIds = getLinkedVariantIds(giftItem);
      const otherLinkedItemExists = hasRemainingLinkedMainItem(cart, linkedIds, removedItemKeys);

      if (!otherLinkedItemExists) {
        nextUpdates[giftItem.key] = 0;
      }
    });
  });

  if (Object.keys(nextUpdates).length === Object.keys(payload.updates).length) return null;

  return await originalFetch(url, {
    ...options,
    headers: {
      ...(options.headers || {}),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ...payload,
      updates: nextUpdates,
    }),
  });
}

function installFreeGiftCartCleanupHook() {
  if (window.__freeGiftCartCleanupHookInstalled) return;
  window.__freeGiftCartCleanupHookInstalled = true;

  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const url = String(args[0]?.url || args[0] || '');

    // ✅ Fetch cart ONCE for all checks in this cycle
    let cart = null;
    if (
      url.includes('/cart/change.js') ||
      url.includes('/cart/update.js') ||
      url.includes('/cart/add.js') ||
      url.includes('/cart/clear.js')
    ) {
      try {
        cart = await originalFetch('/cart.js').then((res) => res.json());
      } catch (e) {
        console.warn('Failed to fetch cart for cleanup checks:', e);
      }
    }

    const pairedRemovalResponse = await removeMainItemWithLinkedGift(args, originalFetch, cart);
    if (pairedRemovalResponse) {
      const hasGift = cart?.items?.some(
        item => isFreeGiftVariant(item.variant_id)
      );

      if (hasGift && !window.__updatingGiftAllocation) {
        scheduleFreeGiftCartCleanup(350);
      }
      return pairedRemovalResponse;
    }

    const pairedUpdateResponse = await updateCartWithLinkedGiftRemoval(args, originalFetch, cart);
    if (pairedUpdateResponse) {
      const hasGift = cart?.items?.some(
        item => isFreeGiftVariant(item.variant_id)
      );

      if (hasGift && !window.__updatingGiftAllocation) {
        scheduleFreeGiftCartCleanup(350);
      }
      return pairedUpdateResponse;
    }

    const response = await originalFetch.apply(this, args);

    if (
      url.includes('/cart/change.js') ||
      url.includes('/cart/update.js') ||
      url.includes('/cart/add.js') ||
      url.includes('/cart/clear.js')
    ) {
      const hasGift = cart?.items?.some(
        item => isFreeGiftVariant(item.variant_id)
      );

      if (hasGift && !window.__updatingGiftAllocation) {
        scheduleFreeGiftCartCleanup(350);
      }
    }

    return response;
  };

  document.addEventListener('click', (event) => {
    const removeButton = event.target.closest('.kaching-cart-item__remove-btn');
    if (!removeButton) return;

    // ✅ Single cleanup call instead of multiple delays
    scheduleFreeGiftCartCleanup(500);
  });
}


// ─── Remove the gift item from the cart ───────────────────────────────
async function _removeGiftItem(giftItem, cart) {
  // UI feedback (only the gift being removed, so the other gift stays untouched)
  const giftElements = getFreeGiftCartElements([giftItem.handle]);

  giftElements.forEach((el) => {
    el.style.opacity = '0.4';
    el.style.pointerEvents = 'none';
    const removeBtn = el.querySelector('.kaching-cart-item__remove-btn');
    if (removeBtn) removeBtn.innerHTML = `<div class="free-gift-remove-loader"></div>`;
  });

  // ✅ Use provided cart instead of fetching
  if (!cart) {
    cart = await fetch('/cart.js').then((r) => r.json());
  }

  const latestLine = cart.items.findIndex((item) => item.key === giftItem.key);
  if (latestLine === -1) return;

  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: latestLine + 1, quantity: 0 }),
  });

  console.log('Free gift removed from cart');
}

// ─── Init Cart Observer ───────────────────────────────────────────────────────
function initFreeGiftUpdater() {
  installFreeGiftCartCleanupHook();

  const run = () => updateFreeGiftItems();
  run();

  const cartDrawer = document.querySelector('.kaching-cart__inner');

  if (!cartDrawer) {
    setTimeout(initFreeGiftUpdater, 300);
    return;
  }

  const observer = new MutationObserver(() => {
    updateFreeGiftItems();
    scheduleFreeGiftCartCleanup(150);
  });

  observer.observe(cartDrawer, { childList: true, subtree: true });
  scheduleFreeGiftCartCleanup(300);
}

initFreeGiftUpdater();

// ============================== DD - Cart experience Changes ==========================

function ensureCartRowInput(form) {
  let input = form.querySelector('.cart-row-id');

  if (!input) {
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[_cart_row_id]';
    input.className = 'cart-row-id';
    form.appendChild(input);
  }

  return input;
}

function generateUniqueId() {
  return (
    crypto.randomUUID?.() ||
    `${Date.now()}-${Math.random().toString(16).slice(2)}`
  );
}

document.addEventListener('click', function (e) {

  const btn = e.target.closest(
    'button[name="add"], .product-form__submit'
  );

  if (!btn) return;

  let form = btn.closest('form[action*="/cart/add"]');

  if (!form) {
    form = btn.closest('form');
  }

  if (form) {
    // free-gift-global-data already set the id its serum gift line is paired with.
    if (window._giftInjecting && form.querySelector('.cart-row-id')?.value) return;
    const input = ensureCartRowInput(form);
    input.value = generateUniqueId();
    return;
  }

  const gpWrapper = btn.closest('gp-product-button');

  if (gpWrapper) {
    const input = ensureCartRowInput(gpWrapper);
    input.value = generateUniqueId();
  }

}, true);


// ============================ New header for seed-3 =====================================

// document.addEventListener('DOMContentLoaded', () => {
//   document.querySelectorAll('.menu-drawer__menu .menu-drawer__menu-item[href*="#"]').forEach((link) => {
//     link.addEventListener('click', function (e) {

//       const href = this.getAttribute('href');
//       const hash = href.split('#')[1];

//       if (!hash) return;

//       const target = document.getElementById(hash);

//       if (!target) return;

//       e.preventDefault();

//       const menuDrawer = document.querySelector('header-drawer');
//       const summary = document.querySelector('#Details-menu-drawer-container > summary');

//       if (menuDrawer && typeof menuDrawer.closeMenuDrawer === 'function') {
//         menuDrawer.closeMenuDrawer(e, summary);
//       }

//       if (summary) {
//         summary.setAttribute('aria-expanded', 'false');
//       }

//       setTimeout(() => {
//         const header =
//           document.querySelector('.section-header') ||
//           document.querySelector('.header-wrapper') ||
//           document.querySelector('header');

//         const headerHeight = header ? header.offsetHeight : 0;

//         function scrollToTarget() {
//           const targetTop =
//             target.getBoundingClientRect().top +
//             window.pageYOffset -
//             headerHeight;

//           // Prevent scrolling beyond the bottom of the page
//           const maxScroll =
//             document.documentElement.scrollHeight - window.innerHeight;

//           window.scrollTo({
//             top: Math.min(targetTop, maxScroll),
//             behavior: 'smooth'
//           });
//         }

//         // Initial scroll
//         scrollToTarget();

//         // Recalculate after layout changes (drawer closing, lazy images, etc.)
//         requestAnimationFrame(scrollToTarget);

//         setTimeout(scrollToTarget, 300);
//         setTimeout(scrollToTarget, 700);

//         window.addEventListener(
//           'load',
//           () => {
//             scrollToTarget();
//           },
//           { once: true }
//         );

//       }, 400);
//     });
//   });
// });

function isGemPage() {
  const path = window.location.pathname;

  return (
    path.includes('/a/gempages') ||
    path.includes('/pages/ay-o1') ||
    path.includes('/pages/pl-m1') ||
    path.includes('/pages/ut-a1') ||
    path.includes('/pages/an-ke-1-i1') ||
    path.includes('/pages/an-ke-1') ||
    path.includes('/pages/ay-lp6g') ||
    path.includes('/pages/ay-lp6g-comp') ||
    path.includes('/pages/pms')
  );
}

document.addEventListener('DOMContentLoaded', () => {
  // Skip this script on GemPages
  if (isGemPage()) return;

  document.querySelectorAll(
    '.menu-drawer__menu .menu-drawer__menu-item[href*="#"], .header__menu-item[href*="#"]'
  ).forEach((link) => {

    link.addEventListener('click', function (e) {

      const href = this.getAttribute('href');
      const hash = href.split('#')[1];

      if (!hash) return;
      const target = document.getElementById(hash);

      if (!target) return;
      e.preventDefault();

      const menuDrawer = document.querySelector('header-drawer');
      const summary = document.querySelector('#Details-menu-drawer-container > summary');

      // Close mobile drawer only
      if (
        this.closest('.menu-drawer__menu') &&
        menuDrawer &&
        typeof menuDrawer.closeMenuDrawer === 'function'
      ) {
        menuDrawer.closeMenuDrawer(e, summary);

        if (summary) {
          summary.setAttribute('aria-expanded', 'false');
        }
      }

      const delay = this.closest('.menu-drawer__menu') ? 400 : 0;

      setTimeout(() => {
        function getTargetPosition() {
          return (
            target.getBoundingClientRect().top +
            window.pageYOffset
          );
        }

        function scrollToTarget(behavior = 'smooth') {
          const targetTop = getTargetPosition();
          const maxScroll =
            document.documentElement.scrollHeight -
            window.innerHeight;

          window.scrollTo({
            top: Math.min(targetTop, maxScroll),
            behavior
          });
        }

        // Main smooth scroll
        scrollToTarget('smooth');
        // Wait for smooth scrolling to finish,
        // then check if layout moved
        setTimeout(() => {
          const currentPosition = getTargetPosition();
          const difference = Math.abs(currentPosition - window.scrollY);

          if (difference > 5) {
            window.scrollTo({
              top: currentPosition,
              behavior: 'smooth'
            });
          }
        }, 500);

        // Final safety check for lazy loaded content
        setTimeout(() => {
          const currentPosition = getTargetPosition();
          const difference = Math.abs(currentPosition - window.scrollY);

          if (difference > 5) {
            window.scrollTo({
              top: currentPosition,
              behavior: 'auto'
            });
          }
        }, 1200);
      }, delay);
    });
  });
});

// ======================= footer popup for seed-3 ====================================

document.addEventListener("DOMContentLoaded", function () {

  if (!document.body.classList.contains("product--seed-3")) {
    return;
  }

  const popup = document.querySelector("#pagePopup");
  const popupContent = document.querySelector("#popupContent");
  const closeBtn = document.querySelector(".popup-close");
  const overlay = document.querySelector(".popup-overlay");

  if (!popup || !popupContent) {
    console.log("Popup HTML missing");
    return;
  }

  const cache = new Map();

  const footerLinks = document.querySelectorAll(
    "footer a.list-menu__item--link"
  );

  console.log("Footer popup links found:", footerLinks.length);

  footerLinks.forEach(link => {
    link.addEventListener("click", function (e) {
      e.preventDefault();

      const url = this.href;

      popup.classList.add("active");
      document.body.style.overflow = "hidden";

      if (cache.has(url)) {
        popupContent.innerHTML = cache.get(url);
        return;
      }

      popupContent.innerHTML = `
        <div class="popup-loader">
          Loading...
        </div>
      `;

      console.log("Fetching URL:", url);

      fetch(url)
        .then(response => response.text())
        .then(html => {

          const doc = new DOMParser()
            .parseFromString(html, "text/html");

          const policyTitle = doc.querySelector(".shopify-policy__title");
          const policyBody = doc.querySelector(".shopify-policy__body");

          let finalContent = "";

          if (policyTitle || policyBody) {

            finalContent = `
              ${policyTitle ? policyTitle.outerHTML : ""}
              ${policyBody ? policyBody.outerHTML : ""}
            `;

          } else {

            const content =
              doc.querySelector("main .rte") ||
              doc.querySelector(".page-width .rte") ||
              doc.querySelector(".template-page .rte") ||
              doc.querySelector(".main-page-content") ||
              doc.querySelector(".page-content") ||
              doc.querySelector("main");

            finalContent = content
              ? content.innerHTML
              : "<p>Content not found</p>";
          }

          cache.set(url, finalContent);

          popupContent.innerHTML = finalContent;

        })
        .catch(error => {

          console.error("Popup fetch error:", error);

          popupContent.innerHTML = `
            <p>Something went wrong. Please try again.</p>
          `;
        });
    });
  });

  function closePopup() {
    popup.classList.remove("active");
    popupContent.innerHTML = "";
    document.body.style.overflow = "";
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", closePopup);
  }

  if (overlay) {
    overlay.addEventListener("click", closePopup);
  }
});

// ===================== Seed-3 Header Redirect ==================

document.addEventListener("DOMContentLoaded", function () {

  if (!document.body.classList.contains("product--seed-3")) {
    return;
  }

  const logoLink = document.querySelector(".header__heading-link");

  if (logoLink) {
    logoLink.href = window.location.pathname;
  }
});

// ====================== LP002 - Isolate the Gempage Lps =======================

document.addEventListener("DOMContentLoaded", function () {

  if (!isGemPage()) return;

  const sections = {
    ".money-back-section": "money-back-guarantee",
    ".faq-section": "faq-section",
    ".review-section": "review"
  };

  Object.entries(sections).forEach(([selector, id]) => {
    const element = document.querySelector(selector);
    if (element) {
      element.id = id;
    }
  });
});

// ay-lp6g-comp mobile drawer redirection on specific section

(function () {
  // Only run on the specified page
  if (window.location.pathname !== "/pages/ay-lp6g-comp") return;

  const sections = {
    "money-back-guarantee": {
      selector: ".money-back-section-mobile",
      mobileId: "money-back-guarantee-mobile"
    },
    "faq-section": {
      selector: ".faq-section-mobile",
      mobileId: "faq-section-mobile"
    },
    "review": {
      selector: ".review-section-mobile",
      mobileId: "review-mobile"
    }
  };

  function updateNavigation() {
    const isMobile = window.matchMedia("(max-width: 749px)").matches;

    Object.entries(sections).forEach(([originalId, section]) => {
      const element = document.querySelector(section.selector);

      if (element) {
        if (isMobile) {
          element.id = section.mobileId;
        } else if (element.id === section.mobileId) {
          element.removeAttribute("id");
        }
      }
    });

    document.querySelectorAll(
      ".menu-drawer__navigation .menu-drawer__menu-item[href*='#']"
    ).forEach(function (link) {
      const href = link.getAttribute("href");
      if (!href) return;

      const currentId = href.split("#").pop();

      Object.entries(sections).forEach(([originalId, section]) => {
        if (currentId === originalId || currentId === section.mobileId) {
          link.setAttribute(
            "href",
            isMobile ? "#" + section.mobileId : "#" + originalId
          );
        }
      });
    });
  }

  // Run on page load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", updateNavigation);
  } else {
    updateNavigation();
  }

  // Run whenever viewport size changes
  window.addEventListener("resize", updateNavigation);
})();

 
// document.addEventListener('DOMContentLoaded', () => {
//   const path = window.location.pathname;

//   // Only this page
//   if (!path.includes('/pages/ay-lp6g-comp')) return;

//   // Mobile only
//   if (!window.matchMedia('(max-width: 749px)').matches) return;

//    const sectionMap = {
//     ".money-back-section-mobile": "money-back-guarantee-mobile",
//     ".faq-section-mobile": "faq-section-mobile",
//     ".review-section-mobile": "review-mobile"
//   };

//   document.querySelectorAll(
//     '.menu-drawer__menu .menu-drawer__menu-item[href*="#"]'
//   ).forEach((link) => {
//     const href = link.getAttribute('href');
//     if (!href) return;

//     const originalId = href.split('#')[1];

//     if (sectionMap[originalId]) {
//       link.setAttribute('href', sectionMap[originalId]);
//     }
//   });
// });

// document.addEventListener('DOMContentLoaded', () => {
//   const path = window.location.pathname;

//   // Run only on the specified page
//   if (!path.includes('/pages/ay-lp6g-comp')) return;

//   // Run only on mobile
//   if (!window.matchMedia('(max-width: 749px)').matches) return;

//   const sectionMap = {
//     ".money-back-section-mobile": "money-back-guarantee-mobile",
//     ".faq-section-mobile": "faq-section-mobile",
//     ".review-section-mobile": "review-mobile"
//   };

//   document.querySelectorAll(
//     '.menu-drawer__menu .menu-drawer__menu-item[href*="#"]'
//   ).forEach((link) => {
//     link.addEventListener('click', function (e) {
//       const href = this.getAttribute('href');
//       if (!href) return;

//       const hash = href.split('#')[1];
//       const targetId = sectionMap[hash];

//       if (!targetId) return;

//       const target = document.getElementById(targetId);
//       if (!target) return;

//       e.preventDefault();

//       // Close the mobile drawer
//       const menuDrawer = document.querySelector('header-drawer');
//       const summary = document.querySelector(
//         '#Details-menu-drawer-container > summary'
//       );

//       if (
//         menuDrawer &&
//         typeof menuDrawer.closeMenuDrawer === 'function'
//       ) {
//         menuDrawer.closeMenuDrawer(e, summary);
//       }

//       if (summary) {
//         summary.setAttribute('aria-expanded', 'false');
//       }

//       // Wait for the drawer to close before scrolling
//       setTimeout(() => {
//         function getTargetPosition() {
//           const header = document.querySelector(
//             '.shopify-section-header'
//           );

//           const headerHeight = header
//             ? header.getBoundingClientRect().height
//             : 0;

//           return (
//             target.getBoundingClientRect().top +
//             window.pageYOffset -
//             headerHeight -
//             10
//           );
//         }

//         function scrollToTarget(behavior = 'smooth') {
//           const maxScroll =
//             document.documentElement.scrollHeight -
//             window.innerHeight;

//           window.scrollTo({
//             top: Math.max(
//               0,
//               Math.min(getTargetPosition(), maxScroll)
//             ),
//             behavior
//           });
//         }

//         // Initial scroll
//         scrollToTarget('smooth');

//         // Recheck after layout changes
//         setTimeout(() => {
//           if (!target.isConnected) return;

//           if (Math.abs(getTargetPosition()) > 5) {
//             scrollToTarget('smooth');
//           }
//         }, 700);

//         // Final position correction
//         setTimeout(() => {
//           if (!target.isConnected) return;

//           if (Math.abs(getTargetPosition()) > 5) {
//             scrollToTarget('auto');
//           }
//         }, 1200);
//       }, 400);
//     });
//   });
// });

// document.addEventListener('click', function (e) {

//   const link = e.target.closest('a[href^="#"]');
//   if (!link) return;

//   if (!isGemPage()) return;

//   const id = link.getAttribute('href').substring(1);
//   if (!id) return;

//   const target = document.getElementById(id);
//   if (!target) return;

//   e.preventDefault();
//   e.stopImmediatePropagation();

//   const isMobileMenuLink = link.closest('.menu-drawer__menu');

//   if (isMobileMenuLink) {
//     const menuDrawer = document.querySelector('header-drawer');
//     const details = menuDrawer?.querySelector('details');
//     const menuButton = document.querySelector('.header__icon--menu');

//     if (details) {
//       details.removeAttribute('open');
//     }

//     if (menuButton) {
//       menuButton.setAttribute('aria-expanded', 'false');
//     }
//     document.querySelectorAll('.menu-opening').forEach((el) => {
//       el.classList.remove('menu-opening');
//     });
//     document.body.classList.remove('overflow-hidden');
//     document.documentElement.classList.remove('overflow-hidden');
//   }

//   const delay = isMobileMenuLink ? 600 : 50;

//   setTimeout(() => {
//     function getTargetPosition() {
//       return (
//         target.getBoundingClientRect().top +
//         window.scrollY
//       );
//     }

//     function scrollToTarget(behavior = 'smooth') {
//       const y = getTargetPosition();
//       const maxScroll =
//         document.documentElement.scrollHeight -
//         window.innerHeight;

//       window.scrollTo({
//         top: Math.min(y, maxScroll),
//         behavior
//       });
//     }

//     // Initial smooth scroll
//     scrollToTarget('smooth');

//     // Small correction after layout settles
//     setTimeout(() => {
//       const currentPosition = getTargetPosition();
//       const difference = Math.abs(currentPosition - window.scrollY);

//       if (difference > 5) {
//         window.scrollTo({
//           top: currentPosition,
//           behavior: 'auto'
//         });
//       }
//     }, 800);

//     // Final safety check for lazy-loaded content
//     setTimeout(() => {
//       const currentPosition = getTargetPosition();
//       const difference = Math.abs(currentPosition - window.scrollY);

//       if (difference > 5) {
//         window.scrollTo({
//           top: currentPosition,
//           behavior: 'auto'
//         });
//       }
//     }, 1500);
//   }, delay);
// });

// Footer "Back to top" button: always scroll to the very top of the page (works on every template)
if (!window.__ccBackToTopBound) {
  window.__ccBackToTopBound = true;

  document.addEventListener('click', function (e) {
    const backToTop = e.target.closest('.seed-3-footer__back-to-top');
    if (!backToTop) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, true);
}
document.addEventListener('click', function (e) {

  const link = e.target.closest('a[href^="#"]');
  if (!link) return;
    const isQuizResultPage = window.location.pathname === '/pages/quiz-result';

  if (!(isGemPage() || isQuizResultPage)) return;

  const id = link.getAttribute('href').substring(1);
  if (!id) return;

  const target = document.getElementById(id);
  if (!target) return;

  e.preventDefault();
  e.stopImmediatePropagation();

  const isMobileMenuLink = link.closest('.menu-drawer__menu');

  if (isMobileMenuLink) {
    const menuDrawer = document.querySelector('header-drawer');
    const details = menuDrawer?.querySelector('details');
    const menuButton = document.querySelector('.header__icon--menu');

    if (details) {
      details.removeAttribute('open');
    }

    if (menuButton) {
      menuButton.setAttribute('aria-expanded', 'false');
    }

    document.querySelectorAll('.menu-opening').forEach((el) => {
      el.classList.remove('menu-opening');
    });

    document.body.classList.remove('overflow-hidden');
    document.documentElement.classList.remove('overflow-hidden');
  }

  const delay = isMobileMenuLink ? 600 : 50;

  setTimeout(() => {

    function getTargetPosition() {
      const announcementBarHeight =
        parseFloat(
          getComputedStyle(document.documentElement)
            .getPropertyValue('--cc-announcement-bar-height')
        ) || 0;

      return (
        target.getBoundingClientRect().top +
        window.scrollY -
        announcementBarHeight
      );
    }

    function scrollToTarget(behavior = 'smooth') {
      const y = getTargetPosition();

      const maxScroll =
        document.documentElement.scrollHeight -
        window.innerHeight;

      window.scrollTo({
        top: Math.max(0, Math.min(y, maxScroll)),
        behavior
      });
    }

    // Initial smooth scroll
    scrollToTarget('smooth');

    // Small correction after layout settles
    setTimeout(() => {
      const currentPosition = getTargetPosition();
      const difference = Math.abs(currentPosition - window.scrollY);

      if (difference > 5) {
        window.scrollTo({
          top: Math.max(0, currentPosition),
          behavior: 'auto'
        });
      }
    }, 800);

    // Final safety check for lazy-loaded content
    setTimeout(() => {
      const currentPosition = getTargetPosition();
      const difference = Math.abs(currentPosition - window.scrollY);

      if (difference > 5) {
        window.scrollTo({
          top: Math.max(0, currentPosition),
          behavior: 'auto'
        });
      }
    }, 1500);

  }, delay);
});


// -================================== ID00XX - PDP - Sub only changes =========================-
(function () {
  function updateRefillDays() {

    if (!document.body.classList.contains('pdp-seed3-ab-sub-0002--template')) {
      return;
    }
    const selectedBar = document.querySelector(
      '.kaching-bundles__bar.kaching-bundles__bar--selected'
    );

    if (!selectedBar) return;

    const subtitle = selectedBar.querySelector(
      '.kaching-bundles__bar-subtitle'
    );

    if (!subtitle) return;

    // Example:
    // "1-Month Supply"
    // "3-Month Supply | Pay for 2 Month..."
    // "5-Month Supply | Pay for 3 Months..."

    const match = subtitle.textContent.match(/(\d+)\s*-\s*Month/i);

    if (!match) return;

    const months = parseInt(match[1], 10);

    if (isNaN(months)) return;

    const days = months * 30;

    const refillText = document.querySelector(
      '.seed3-ab-sub-icons .icon-item:first-child .icon-item-text'
    );

    if (!refillText) return;

    refillText.textContent = `Refills Ship Every ${days} Days`;
  }

  function initRefillDaysObserver() {
    updateRefillDays();

    const bundleContainer = document.querySelector('.kaching-bundles__bars');

    if (!bundleContainer) {
      setTimeout(initRefillDaysObserver, 300);
      return;
    }

    const observer = new MutationObserver(() => {
      updateRefillDays();
    });

    observer.observe(bundleContainer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  initRefillDaysObserver();
})();
